import { ShieldTick } from "iconsax-react";
import { BsClock } from "react-icons/bs";
import styled from "styled-components";

import { Widget as WidgetStyled } from "@CheckoutStepsOffers/styles/Widget";

export const BillingInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
  margin: 1rem 0 0;
`;

export const Widget = styled(WidgetStyled)`
  height: 100%;
`;

export const Strong = styled.strong`
  display: flex;
  align-items: center;

  margin: 0 0 0.5rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const Description = styled.p`
  margin: 0;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const ClockIcon = styled(BsClock)`
  margin: 0 0.5rem 0 0;

  font-size: 1.25rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const ShieldIcon = styled(ShieldTick)`
  margin: 0 0.5rem 0 0;

  font-size: 1.25rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;
